import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2003Status: 'idle',
    startProcess2003Error: undefined as any,
    loadUserParamsProcess2003Status: 'idle',
    loadUserParamsProcess2003Error: undefined as any,

    process2003List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2003 = createAsyncThunk('process2003Slice/startProcess2003', async ({ process2003 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2003/`,
        prepareData(process2003),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2003Status } = getState().process2003Slice
        return startProcess2003Status !== 'pending'
    }
})

export const loadUserParamsProcess2003 = createAsyncThunk('process2003Slice/loadUserParamsProcess2003', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2003/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2003Status } = getState().process2003Slice
        return loadUserParamsProcess2003Status !== 'pending'
    }
})

const Process2003Slice = createSlice({
    name: 'process2003Slice',
    initialState,
    reducers: {
        resetstartProcess2003: (state) => {
            state.job = undefined
            state.startProcess2003Error = undefined
        },
        resetstartProcess2003Error: (state) => {
            state.startProcess2003Error = undefined
        },
        resetloadUserParamsProcess2003: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2003Error = undefined
        },
        resetloadUserParamsProcess2003Error: (state) => {
            state.loadUserParamsProcess2003Error = undefined
        },
        removeFromProcess2003ListById: (state, action) => {
            state.process2003List = state.process2003List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2003ListByIds: (state, action) => {
            state.process2003List = state.process2003List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2003List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2003Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2003List = []
            state.startProcess2003Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2003.pending, (state) => {
            state.startProcess2003Status = 'pending'
            state.startProcess2003Error = undefined
        })
        builder.addCase(startProcess2003.fulfilled, (state, action) => {
            state.startProcess2003Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2003.rejected, (state, action) => {
            state.startProcess2003Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2003Error = action.error.message
            } else {
                state.startProcess2003Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2003.pending, (state) => {
            state.loadUserParamsProcess2003Status = 'pending'
            state.loadUserParamsProcess2003Error = undefined
        })
        builder.addCase(loadUserParamsProcess2003.fulfilled, (state, action) => {
            state.loadUserParamsProcess2003Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2003.rejected, (state, action) => {
            state.loadUserParamsProcess2003Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2003Error = action.error.message
            } else {
                state.loadUserParamsProcess2003Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2003,
    resetstartProcess2003Error,
    resetloadUserParamsProcess2003,
    resetloadUserParamsProcess2003Error,
    removeFromProcess2003ListById,
    removeFromProcess2003ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2003Slice.actions
export default Process2003Slice.reducer
